'use client'
import React, { useState, useEffect } from 'react'
import LargePropertyCard from '@components/LargePropertyCard'
import LoadingCard from '@components/LoadingCard'
import { getFilteredProperties2 } from '@services/getFilteredProperties2'
import { saleTypes } from '@constants/saleTypes'
import { company } from '@constants/company'
import { useRouter } from 'next/navigation'

const SearchResultCards = ({ searchParams, dictionary, lang = 'en' }) => {
    const router = useRouter();

    // const { data: session } = useSession()
    let userEmail = null

    // const [currency, setCurrencyType] = useState('thb')
    const [isLoading, setIsLoading] = useState(false)
    const [search, setSearch] = useState(searchParams)
    const [page, setPage] = useState(1);
    const [allPages, setAllPages] = useState(1);
    // const [properties, setProperties] = useState([]);
    const [properties, setProperties] = useState([]);
    const [propertyCount, setPropertyCount] = useState(0);
    // const [showMap, setShowMap] = useState(false)
    const [coordinates, setCoordinates] = useState([])
    const [hoveredProperty, setHoveredProperty] = useState(null)
    const [activeProperty, setActiveProperty] = useState({})
    const [activePropertyLat, setActivePropertyLat] = useState(13.732772)
    const [activePropertyLng, setActivePropertyLng] = useState(100.5801953)

    // if (session !== null) {
    //     userEmail = session?.user?.email
    // }

    const handleMouseEnter = (propertyId) => {
        // console.log(e)
        // console.log('hover ' + propertyId)
        setHoveredProperty(propertyId)
    };
    const handleMouseLeave = () => {
        // console.log('hover end')
        setHoveredProperty(null)
    };

    const handleSlideChange = (swiper) => {
        // Emit your event or perform actions when the active slide changes
        const activeSlideIndex = swiper.activeIndex;
        // console.log(`Active slide index: ${activeSlideIndex}`);
        let activePropertyId = swiper.slides[activeSlideIndex].id
        let activePropertyLat = swiper.slides[activeSlideIndex].dataset.latitude
        let activePropertyLng = swiper.slides[activeSlideIndex].dataset.longitude
        setActiveProperty(activePropertyId)
        setActivePropertyLat(activePropertyLat)
        setActivePropertyLng(activePropertyLng)

        // Emit an event or perform actions here
    };

    const getData = async (pageNumber) => {
        setIsLoading(true)
        const result = await getFilteredProperties2({
            name: searchParams.name || '',
            saleType: searchParams.saleType || saleTypes[lang][0].value,
            bts: searchParams.bts || '',
            district: searchParams.district || '',
            districts: searchParams.districts || '',
            area: searchParams.area || '',
            location: searchParams.location || '',
            project: searchParams.project || '',
            category: searchParams.category || '',
            categories: searchParams.categories || '',
            minBedrooms: searchParams.minBedrooms || '',
            maxBedrooms: searchParams.maxBedrooms || '',
            room: searchParams.room || '',
            rooms: searchParams.rooms || '',
            currency: searchParams.currency || 'thb',
            minprice: searchParams.minprice || '',
            maxprice: searchParams.maxprice || '',
            petfriendly: searchParams.petfriendly || '',
            seaview: searchParams.seaview || '',
            beachfront: searchParams.beachfront || '',
            map: searchParams.map || false,
            sort: searchParams.sort || 'datedesc',
            area: searchParams.area || '',
            foreignquota: searchParams.foreignquota || '',
            limit: searchParams.limit || 8,
            page: pageNumber
        },
            userEmail
        )

        // setProperties(result.properties)
        if (pageNumber > 1) {
            setProperties((prev) => [...prev, ...result.properties])
        } else {
            setProperties(result.properties)
        }
        setAllPages(result.pages)
        setPropertyCount(result.count)
        setCoordinates(result.coordinates)
        if (result.properties.length > 0 && page == 1) {
            setActiveProperty(result.properties[0].id)
            setActivePropertyLat(Number(result.properties[0].latitude))
            setActivePropertyLng(Number(result.properties[0].longitude))
        }
        setIsLoading(false)
    }

    // useEffect(() => {
    //     setPage(1)
    //     setProperties([])

    //     // If you want to push params on param change, be sure not to cause infinite loops.
    //     // For example, if you want to normalize or add params:
    //     const newSearchParams = new URLSearchParams(window.location.search);
    //     const currentUrl = window.location.pathname + window.location.search
    //     getData()
    //     // Only push if URL is different to prevent loops
    //     if (currentUrl !== `${window.location.pathname}?${newSearchParams}`) {
    //         router.push(`${window.location.pathname}?${newSearchParams}`)
    //     }
    // }, [searchParams])

    // useEffect(() => {
    //     if (page > 1) {
    //         getData()
    //     }
    // }, [page])

    // useEffect(() => {
    //     // Only fetch if page > 1, because page = 1 is already handled in searchParams effect
    //     if (page > 1) {
    //         getData()
    //     }
    // }, [page])

    // useEffect(() => {
    //     if (page !== 1) {
    //         setPage(1)
    //     } else {
    //         setProperties([])
    //         getData()
    //     }
    // }, [searchParams])

    useEffect(() => {
        setPage(1)
        setProperties([])
        // setShowMap(searchParams.map)

        getData(1)
    }, [searchParams])

    useEffect(() => {
        getData(page)
    }, [page])

    return (
        <div className='md:w-full 2xl:w-10/12 max-w-[1600px] flex md:flex-row flex-col flex-nowrap md:flex-wrap mx-auto md:px-3 px-0'>
            <>
                {properties.map((property, index) => (
                    <div
                        key={property.id}
                        className='m-2'
                    >
                        <LargePropertyCard
                            saleType={searchParams?.name?.toLowerCase()?.startsWith(company?.refStarter) ? '' : searchParams.saleType }
                            dictionary={dictionary.card}
                            lang={lang}
                            property={property}
                            isLast={index === properties.length - 1}
                            imageWidth={320}
                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                        />
                    </div>
                ))}
                {isLoading && (  
                    <div className='m-2'>
                        <LoadingCard />
                    </div>  
                )}
                {isLoading && (  
                    <div className='m-2'>
                        <LoadingCard />
                    </div>  
                )}
                {isLoading && (  
                    <div className='m-2'>
                        <LoadingCard />
                    </div>  
                )}
                {isLoading && (  
                    <div className='m-2'>
                        <LoadingCard />
                    </div>  
                )}
                {isLoading && (  
                    <div className='m-2'>
                        <LoadingCard />
                    </div>  
                )}
            </>
        </div>
    )
}

export default SearchResultCards